<template>
    <div v-if="progress != null" class="progress-wrap">

        <component :is="typeOfSubmission(submission)" :submissions="[submission]" :key="progress.id" class="progress-preview"></component>

        <div class="progress-feedback" v-if="progress.feedback || progress.diligence">
            <template v-if="progress.feedback">
                <teacher-feedback :feedback="$store.state.feedback.storage[ progress.feedback ]" :minimal="true"></teacher-feedback>
            </template>

            <template v-if="progress.diligence">
                <h3><span>Beoordeling</span></h3>
                <diligence :progress="progress" :readonly="true" :showOnlySelected="true"></diligence>
            </template>
        </div>

    </div>

    <span v-else>Geen voortgang</span>
</template>


<script>

import TeacherFeedback from 'js/components/assignment/presenters/TeacherFeedback.vue'
import Diligence from 'js/components/assignment/Diligence.vue'
import Question from 'js/components/assignment/presenters/Question.vue'
import Upload from 'js/components/assignment/presenters/Upload.vue'

export default {
    components: { TeacherFeedback, Diligence, Question, Upload },
    props: {
        progress: {},
    },

    computed: {

        submission: function() {
            return this.submissions[ this.submissions.length - 1 ]
        },

        submissions: function() {
            if ( this.progress == null ) {
                return []
            }
            return this.progress.primarySubmissions.map( id => this.$store.state.submissions.storage[id] ).filter( s => s != null )
        }
    },

    methods: {

        typeOfSubmission: function(submission) {

            return (submission.data instanceof Object && submission.data.medium != null && submission.data.thumb != null)
                ? 'Upload'
                : 'Question'
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .progress-wrap {
        @include clearfix();
    }

    .progress-preview {
        width: 44%;
        float: left;
        padding-right: 2%;

        .answer {
            min-width: auto;
        }
    }

    .progress-feedback {
        width: 56%;
        float: left;
        padding: 0 1em 1em;
        margin: 1em 0;
        border: 1px solid $color-light-grey;
        border-radius: 4px;
    }

</style>



// WEBPACK FOOTER //
// Progress.vue?2a436d40